module.exports = __webpack_public_path__ + "static/img/u10.d41da495.png";